import useSWR from 'swr';
import { useFetcher, usePublicFetcher } from './use-fetcher';
import { salesOfficeAreaId } from '../../constants';
import { IOnlineTourSearchResult } from '../../utils/types';

export function useTourSearchDetail(props: { id: number }) {
  const fetcher = usePublicFetcher({
    method: 'POST',
  });
  const { data, error, isLoading } = useSWR<IOnlineTourSearchResult[]>(
    `/api/online/tour-search?salesOfficeAreaId=${salesOfficeAreaId}&id=${props.id}`,
    fetcher,
  );
  return {
    data: data ? data[0] : undefined,
    error,
    isLoading,
  };
}

export function useTourSearch(props: {
  endDate?: Date;
  page?: number;
  size?: number;
  sort?: string;
  startDate?: Date;
  id?: number;
}) {
  const fetcher = useFetcher();
  const qp = new URLSearchParams();
  if (props.id) {
    qp.append('id', props.id.toString());
  }
  if (props.endDate) {
    qp.append('endDate', props.endDate.toISOString());
  }
  if (props.page) {
    qp.append('page', props.page.toString());
  }
  if (props.size) {
    qp.append('size', props.size.toString());
  }
  if (props.sort) {
    qp.append('sort', props.sort);
  }
  qp.append('salesOfficeAreaId', salesOfficeAreaId.toString());

  const { data, error, isLoading } = useSWR<IOnlineTourSearchResult[]>(
    `/api/online/tour-search?${qp.toString()}`,
    fetcher,
  );
  return {
    data,
    error,
    isLoading,
  };
}
